import { BuilderComponentGroup } from '../types'

export const TeamDesignBlocks: BuilderComponentGroup = {
  id: 'team',
  title: 'Team',
  components: [
    {
      compId: 'team1',
      title: 'Team 1',
      icon: 'Profile1',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'team2',
      title: 'Team 2',
      icon: 'Profile1',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'team3',
      title: 'Team 3',
      icon: 'Profile1',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'team4',
      title: 'Team 4',
      icon: 'Profile1',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    {
      compId: 'team5',
      title: 'Team 5',
      icon: 'Profile1',
      nested: false,
      isDesignBlock: true,
      settings: {},
    },
    // {
    //   compId: 'team6',
    //   title: 'Team 6',
    //   icon: 'Profile1',
    //   nested: false,
    //   isDesignBlock: true,
    //   settings: {},
    // },
  ],
}
